/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Gate_CallInputs */

const en_landing_gate_call = /** @type {(inputs: Landing_Gate_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call the studio`)
};

const pl_landing_gate_call = /** @type {(inputs: Landing_Gate_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadzwoń do studia`)
};

/**
* | output |
* | --- |
* | "Call the studio" |
*
* @param {Landing_Gate_CallInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_gate_call = /** @type {((inputs?: Landing_Gate_CallInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Gate_CallInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_gate_call(inputs)
	return en_landing_gate_call(inputs)
});